import { cn } from '@/lib/utils'
import { useStudioLocale } from '@/i18n'

interface TierBadgeProps {
  tier: 'A' | 'B'
  className?: string
}

export function TierBadge({ tier, className }: TierBadgeProps) {
  const copy = useStudioLocale().strings.starters.gallery
  return (
    <span
      className={cn(
        'text-[10px] px-2 py-1 rounded font-medium',
        tier === 'A'
          ? 'bg-amber-500/10 text-amber-600'
          : 'bg-blue-500/10 text-blue-600',
        className,
      )}
    >
      {copy.tier(tier)}
    </span>
  )
}
